export const StringMatchService = Symbol.for('StringMatchService');
